type DotNavigationItem = {
  id: string;
  label: string;
};

type DotNavigationProps = {
  chapters: DotNavigationItem[];
  activeChapterId: string;
  onNavigate: (chapterId: string) => void;
  disabledChapterIds?: string[];
};

export const DotNavigation = ({
  chapters,
  activeChapterId,
  onNavigate,
  disabledChapterIds = [],
}: DotNavigationProps) => {
  const disabledSet = new Set(disabledChapterIds);

  return (
    <nav className="about-dot-nav" aria-label="About sections">
      {chapters.map((chapter) => {
        const isActive = chapter.id === activeChapterId;
        const isDisabled = disabledSet.has(chapter.id);
        return (
          <button
            key={chapter.id}
            type="button"
            className={`about-dot-nav__item${isActive ? " is-active" : ""}${isDisabled ? " is-disabled" : ""}`}
            onClick={() => onNavigate(chapter.id)}
            aria-label={chapter.label}
            aria-current={isActive ? "true" : undefined}
            aria-disabled={isDisabled ? "true" : undefined}
            disabled={isDisabled}
          >
            <span className="about-dot-nav__dot" aria-hidden="true" />
            <span className="about-dot-nav__label" aria-hidden="true">
              {chapter.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};
